import React from 'react'
import ReactPaginate from 'react-paginate'
import { orange } from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import styled from 'styled-components'

interface Props {
  itemSize: number
  setIndex: (pageIndex: number) => void
  forcePage: number
  onePageDisplayItems?: number
}

const LAST_DISPLAY_SIZE = 1
const AROUND_DISPLAY_PAGES = 3

export const Pagination = (props: Props) => {
  const { itemSize, setIndex, forcePage, onePageDisplayItems } = props

  const ONE_PAGE_DISPLAY_ITEMS = onePageDisplayItems || 15

  const handlePaginate = (selectedItem: { selected: number }) => {
    const page = selectedItem.selected + 1
    setIndex(page)
  }

  const calculatePageCount = () => {
    return Math.ceil(itemSize / ONE_PAGE_DISPLAY_ITEMS)
  }

  return (
    <PaginationWrapper>
      <ReactPaginate
        pageCount={calculatePageCount()}
        marginPagesDisplayed={LAST_DISPLAY_SIZE}
        pageRangeDisplayed={AROUND_DISPLAY_PAGES}
        onPageChange={handlePaginate}
        containerClassName="pagination"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        activeClassName="active"
        activeLinkClassName="active"
        previousLinkClassName="previous-link"
        nextLinkClassName="next-link"
        previousLabel="<"
        nextLabel=">"
        disabledClassName="disabled-button"
        forcePage={forcePage}
      />
    </PaginationWrapper>
  )
}

const PaginationWrapper = styled.div`
  .pagination {
    display: flex;
    justify-content: center;
    padding-left: 0;
    margin: 19px 0;
    border-radius: 4px;
    bottom: 10px;
    left: 0;
    width: 100%;
    text-align: center;
    font-weight: ${fontWeightBold};
  }
  .pagination li a {
    margin: 0 8px;
    overflow: hidden;
  }
  .pagination li {
    font-size: 18px;
  }
  .active {
    color: ${orange};
  }
  .disabled-button {
    display: none;
  }
`
